import {cn} from "@/lib/utils";

export interface UserTypingProps {
  size: number
  className?: string
}
export default function UserTyping({size, className}: UserTypingProps) {
  return (
    <div className={cn(
      'flex justify-between gap-1 box-border',
      className)}
    data-testid="user-typing"
    >
      <div style={{width: `${size}rem`, height: `${size}rem`}} className={`bg-blue-500 opacity-0 rounded-full animate-loading-fade delay-0`}/>
      <div style={{width: `${size}rem`, height: `${size}rem`}} className={`bg-blue-500 opacity-0 rounded-full animate-loading-fade delay-300`}/>
      <div style={{width: `${size}rem`, height: `${size}rem`}} className={`bg-blue-500 opacity-0 rounded-full animate-loading-fade delay-700`}/>
    </div>
  )
}